import React, { useState, useEffect } from 'react';
import CustomDropdown from '../../containers/RecruiterVerificationDashboard/components/CustomDropdown';
import getVerifiedCompanies from '../../services/getVerifiedCompanies';

const CompanyDropdown = ({ adminId,  selectedCompany, onCompanySelect }) => {
    const [companyData, setCompanyData] = useState({
        companyList: [],
        isLoading: false,
        searchText: null
    });

    const onSearchChangeHandler = text => {
        setCompanyData(prevObj => {
            const newObj = { ...prevObj, searchText: text };
            if (!text || (text && text.length === 0)) {
                newObj.companyList = [];
                newObj.isLoading = false;
            }
            return newObj;
        });
    };

    const handleClearList = () => {
        setCompanyData(prevObj => ({
            ...prevObj,
            companyList: [],
            isLoading: false,
        }));
    };

    const getCompanies = async () => {
        setCompanyData(prevObj => ({
            ...prevObj,
            isLoading: true
        }));
        try {
            const response = await getVerifiedCompanies(adminId, {
                displayNameLike: companyData.searchText,
                nameSort: 1,
                pageNumber: 1,
                pageContent: 500,
                status: 1,
                targetDomain: process.env.REACT_APP_PLATFORM
            });
            
            if (response.status == 200) {
                setCompanyData(prevObj => ({
                    ...prevObj,
                    companyList: response.data.data.data,
                    isLoading: false
                }));
            }
        } catch (error) {
            setCompanyData(prevObj => ({
                ...prevObj,
                isLoading: false,
            }));
        }
    };

    useEffect(() => {
        let timerID = null;
        try {
            timerID = setTimeout(() => {
                if (!companyData.isLoading && companyData.searchText && companyData.searchText.length >= 2) {
                    getCompanies();
                }
            }, 300);
        } catch (error) {
            console.log(error);
        }
        return () => {
            if (timerID) {
                clearTimeout(timerID);
            }
        }
    }, [companyData.searchText]);

    return (
                <CustomDropdown
                    className="company_dropdown"
                    dropdownList={companyData.companyList.map(item => ({
                        label: `${item.displayName} (${item.id})`,
                        value: item.id,
                        companyName: item.name || item.displayName,
                    }))}
                    isLoading={companyData.isLoading}
                    onInputChange={onSearchChangeHandler}
                    onItemSelected={onCompanySelect}
                    clearList={handleClearList}
                    isSelected={selectedCompany ? { displayName: selectedCompany } : null}
                />
    );
};
export default CompanyDropdown;